module.exports = __webpack_public_path__ + "static/media/Logo_12week_UPTO_1asterisk_en.10e7e9ed.svg";